import React from 'react';
import './style';

const LabelField = ({title,text}) => {
  console.log(title, text)
  return (
    <div className='flex flex-col items-start gap-2'>
      <div className='label-16 text-grey-70'>
        {title}
      </div>
      <div className='label-16'>
        {text === null || text === undefined ? 'N/A' : text}
      </div>
    </div>
  );
};

export default LabelField;
